// Vendor imports
const classNames = require('classnames')
// Shared imports
const Bem = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const defaultBemEntity = Bem.entity('SimpleNav')

// SimpleNavItem component

function SimpleNavItem(props) {
  return (
    tag('a', {
      className: props.bemEntity.element('item', {
        selected: props.selected
      }),
      href: props.href,
      title: props.title,
      onClick: props.onClick
    },
      props.label
    )
  )
}

// SimpleNav component

function SimpleNav(props) {
  const bemEntity = props.bemEntity || defaultBemEntity
  return (
    tag('nav', {
      className: classNames(
        props.className,
        bemEntity.block()
      )
    },
      props.items.map(item => (
        tag(SimpleNavItem, {
          bemEntity,
          key: item.id,
          selected: item.id === props.selectedItemId,
          ...item
        })
      ))
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  const itemPropTypes = {
    // Values
    href: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.node,
    title: PropTypes.string,
    // Callbacks
    onClick: PropTypes.func
  }

  SimpleNavItem.propTypes = {
    ...itemPropTypes,
    bemEntity: PropTypes.instanceOf(Bem.BemEntity).isRequired,
    selected: PropTypes.bool
  }

  SimpleNav.propTypes = {
    bemEntity: PropTypes.instanceOf(Bem.BemEntity),
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape(itemPropTypes)),
    selectedItemId: PropTypes.string
  }
}

// Exports

module.exports = Object.assign(SimpleNav, {
  SimpleNavItem
})
